export default {
  user: {}
}



// WEBPACK FOOTER //
// ./src/components/user/store/state.js